var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRgbOrigin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.84 24.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-190.644 -976.003)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.644 979.896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.439,0l5.813,10.135L17.439,20.271H5.813L0,10.135,5.813,0Z",
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.971437454223633 2.000003814697266 L 2.305587768554688 10.13533401489258 L 6.971437454223633 18.27066421508789 L 16.28020858764648 18.27066421508789 L 20.94606018066406 10.13533401489258 L 16.28020858764648 2.000003814697266 L 6.971437454223633 2.000003814697266 M 5.81291389465332 3.814697265625e-06 L 17.43873405456543 3.814697265625e-06 L 23.25164413452148 10.13533401489258 L 17.43873405456543 20.27066421508789 L 5.81291389465332 20.27066421508789 L 3.814697265625e-06 10.13533401489258 L 5.81291389465332 3.814697265625e-06 Z",
    stroke: "none",
    fill: "inherit"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.889,0l2.963,5.032L8.889,10.064H2.963L0,5.032,2.963,0Z",
    transform: "translate(196.343 985)",
    fill: "inherit"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.75,0,9,4,6.75,8H2.25L0,4,2.25,0Z",
    transform: "translate(210.983 976.003) rotate(60)",
    fill: "#45d2e3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgbOrigin);
export default __webpack_public_path__ + "static/media/rgb_origin.ed93c141da345ba4d5074c2fccd51258.svg";
export { ForwardRef as ReactComponent };